import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-klassen',
  standalone: true,
    imports: [
        RouterLink
    ],
  templateUrl: './klassen.component.html',
  styleUrl: './klassen.component.scss'
})
export class KlassenComponent {

}
